import { useQuery } from '@tanstack/react-query'
import supabase from 'sdk/api'

const getNotifications = async (userId?: string) => {
    const { data, error } = await supabase
        .from('notifications')
        .select(`*, products(*), booking_transactions(*, services(*, menu_category(*)))`)
        .eq('user_id', userId)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetNotifications(userId?: string) {
    return useQuery({
        queryKey: ['useGetNotifications', userId],
        queryFn: () => getNotifications(userId),
        staleTime: 0,
        enabled: !!userId
    })
}
